import { cn } from "../../lib/utils";
export function Button({
	children,
	className,
	variant = "primary",
	size = "md",
	loading = false,
	leftIcon,
	rightIcon,
	disabled,
	...props
}) {
	const variants = {
		primary:
			"bg-primary text-background border-4 border-primary shadow-card hover:bg-accent hover:text-foreground active:bg-secondary active:text-foreground",
		secondary:
			"bg-secondary text-foreground border-4 border-border shadow-card hover:bg-accent hover:text-primary active:bg-primary active:text-background",
		outline:
			"bg-background text-primary border-4 border-primary shadow-card hover:bg-primary hover:text-background",
		ghost:
			"bg-transparent text-primary border-4 border-transparent hover:border-accent hover:bg-accent/20",
		danger:
			"bg-red-600 text-white border-4 border-red-700 shadow-[0_0_8px_2px_rgba(255,0,0,0.7)] hover:bg-red-700 hover:text-white",
	};

	const sizes = {
		sm: "h-8 px-4 text-xs",
		md: "h-10 px-6 text-base",
		lg: "h-12 px-8 text-lg",
	};

	return (
		<button
			className={cn(
				"inline-flex items-center justify-center gap-2 font-display uppercase tracking-widest transition-all duration-200",
				"focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
				"disabled:opacity-50 disabled:cursor-not-allowed",
				"rounded-md", // slightly rounded for a modern coffee look
				variants[variant],
				sizes[size],
				className
			)}
			disabled={loading || disabled}
			{...props}
		>
			{loading && (
				<span className="h-4 w-4 border-2 border-primary border-t-transparent rounded-full animate-spin" />
			)}

			{!loading && leftIcon && <span>{leftIcon}</span>}

			{children}

			{!loading && rightIcon && <span>{rightIcon}</span>}
		</button>
	);
}